import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/styles';

const styles = theme => ({
  image: {
    height: '40px',
    [theme.breakpoints.down('md')]: {
      height: '30px'
    }
  }
});

const Logo = ({ src, alt, classes, dataTestId, logoLinkPath }) => (
  <Button href={logoLinkPath} data-testid="go-to-website">
    <img
      src={src}
      alt={alt}
      className={classes.image}
      data-testid={dataTestId}
    />
  </Button>
);

Logo.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  classes: PropTypes.shape({ image: PropTypes.string }),
  dataTestId: PropTypes.string,
  logoLinkPath: PropTypes.string
};

export default withStyles(styles)(Logo);
